// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ReactiveTable-components-row-TableHead-module__tableHead--XiCp6 {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--table-header-bg, #fafafa);
}
/*# sourceMappingURL=TableHead.module.css.map */`, "",{"version":3,"sources":["webpack://./TableHead.module.less","webpack://./src/components/ReactiveTable/components/row/TableHead.module.less"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,MAAA;EACA,YAAA;EACA,2CAAA;ACDF;AACA,+CAA+C","sourcesContent":["// Стили для шапки таблицы\n\n.tableHead {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: var(--table-header-bg, #fafafa);\n}\n",".tableHead {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: var(--table-header-bg, #fafafa);\n}\n/*# sourceMappingURL=TableHead.module.css.map */"],"sourceRoot":""}]);
// Exports
export var tableHead = `src-components-ReactiveTable-components-row-TableHead-module__tableHead--XiCp6`;
export default ___CSS_LOADER_EXPORT___;
